<template>
  <div class="mark-item-table">
    <div class="subject-header">
      <span>科目：<span style="font-weight: bold;">{{subject.subjectName}}</span></span>
    </div>
    <div class="mark-item-body">
      <div v-for="(item, index) in items" :key="index" v-if="(index+2) % 2 === 0">
        <div class="cell" >
          <div class="cell-room">
            <el-tooltip class="item" effect="dark" :content="index + 1 + '、' + item.divId">
              <span class="divid-name" :style="{width: item.status === 'scored' ? '90px' : '340px'}">{{index + 1}}、{{item.divId}}</span>
            </el-tooltip>
            <div>
              <span v-if="item.status === 'reloading'" class="marking">{{type ? '正评中' : '试评中'}}</span>
              <span class="marking">
                <el-button
                  :disabled = "item.status === 'scored'"
                  :class="{'hollow-btn': true, 'btn-re-open': true, 'has-clicked': item.remark}"
                  :loading="item.reloading"
                  @click="handleReOpenMark(index)">
                  重评
                </el-button>
              </span>
              <span class="error-tip" v-if="item.status === 'notPreMark'">
                <i class="iconfont icon-jinggao-copy check-fail"></i>
                <span class="fail-label">未开试评，请先开启</span>
              </span>
              <span class="error-tip" v-if="item.status === 'scored'">
                <i class="iconfont icon-jinggao-copy check-fail"></i>
                <span class="fail-label">已出分，无法重评</span>
              </span>
            </div>
          </div>
        </div>
         <div class="cell" v-if="items[index+1]">
          <div class="cell-room">
            <el-tooltip class="item" effect="dark" :content="index + 2 + '、' + items[index+1].divId">
              <span class="divid-name" :style="{width: items[index+1].status === 'scored' ? '90px' : '340px'}">{{index + 2}}、{{items[index+1].divId}}</span>
            </el-tooltip>
            <div>
              <span v-if="items[index+1].status === 'reloading'" class="marking">{{type ? '正评中' : '试评中'}}</span>
              <span class="marking">
                <el-button
                  :disabled = "items[index+1].status === 'scored'"
                  :class="{'hollow-btn': true, 'btn-re-open': true, 'has-clicked': items[index+1].remark}"
                  :loading="items[index + 1].reloading"
                  @click="handleReOpenMark(index+1)">
                  重评
                </el-button>
              </span>
              <span class="error-tip" v-if="items[index+1].status === 'notPreMark'">
                <i class="iconfont icon-jinggao-copy check-fail"></i>
                <span class="fail-label">未开试评，请先开启</span>
              </span>
              <span class="error-tip" v-if="items[index+1].status === 'scored'">
                <i class="iconfont icon-jinggao-copy check-fail"></i>
                <span class="fail-label">已出分，无法重评</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img-validate-dialog
     :dialogVisible="dialogVisible"
     confirmLabel="确定"
     @dialogHidden="cancel"
     @hasConfirmed="hasConfirmed"
     ref="validateDialog"
    >
      <p class="error-tip">
        <i class="iconfont icon-iconfontzhizuobiaozhun023132 icon-ling"></i> 重评将清除该题的全部评卷数据
      </p>
      <p class="error-tip">请确认您已知悉该操作所带来的后果</p>
    </img-validate-dialog>
  </div>
</template>

<script>
import { rePjStatus } from '@/model/pj-server-model'
import ImgValidateDialog from '@/components/custom/ImgValidateDialog'
export default {
  name: 'SelectMarkItem',
  components: {
    ImgValidateDialog
  },
  props: {
    // 题目列表 [{name: 'abc', status: ''}]  status: 'notPreMark' || 'unopened', 'opened'
    markItems: {
      type: Array,
      required: true
    },
    // 评卷接口地址
    examId: {
      type: String,
      required: true
    },
    subject: {
      type: Object,
      required: true
    },
    // 评卷类型 试评还是正评 true: 正评 || false：试评
    type: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      dialogVisible: false,
      activceIndex: 0
    }
  },
  watch: {
    markItems (newVal, oldVal) {
      this.makeUpItems(newVal)
    }
  },
  methods: {
    // 题目重评, 随机验证码弹窗
    handleReOpenMark (index) {
      this.activceIndex = index
      this.dialogVisible = true
    },
    // 重新构造数据绑定的对象数组（对原数组里的数据重新复制一份保存到新数组里）
    makeUpItems (todos) {
      this.items =  JSON.parse(JSON.stringify(todos))
      this.items.sort((a,b)=>{
        return parseInt(a.divId) - parseInt(b.divId)
      })
    },
    async hasConfirmed () {
      let confirmText = `重评${this.items[this.activceIndex].divId}`
      let res = await this.$prompt(`<strong style='color: red'>请输入文字 "${confirmText}"</strong>`, '请确认', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).catch(err => {
        console.log(err);       
      });
      if (!res) {
        this.$refs.validateDialog.loadingStatus = false
        return
      } else if (res.value != confirmText) {
        this.$message.error('输入有误!')
        this.$refs.validateDialog.loadingStatus = false
        return
      }
      let index = this.activceIndex
      this.items = JSON.parse(JSON.stringify(this.items))
      let param = {
        examId: this.examId,
        subjectId: this.subject.subjectId,
        divId: this.items[index].divId
      }
      rePjStatus(param).then(pjRes => {
        this.$refs.validateDialog.loadingStatus = false
        this.dialogVisible = false
        if (pjRes.result === 'true') {
          this.alertSuccess('操作成功！')
          this.$refs.validateDialog.setNewCode()
        } else {
          this.alertError('操作失败！')
        }
      }).catch(err => {
        console.log(err)
        this.alertError(err.message || '操作失败！')
        this.$refs.validateDialog.loadingStatus = false
      })
    },
    cancel () {
      this.dialogVisible = false
      this.$refs.validateDialog.setNewCode()
    },
    /**
     * 错误弹窗
     */
    alertError (errorMsg) {
      const h = this.$createElement
      let tipEls = [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--warning`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--warning']
        }, errorMsg)
      ]
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, tipEls)
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success'
      })
    },

    // 成功弹窗
    alertSuccess (msg) {
      const h = this.$createElement
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--success`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--success']
        }, msg)
      ])
      this.$alert(vnode, '', {
        confirmButtonText: '确定',
        center: true,
        showClose: false,
        showCancelButton: false,
        callback: action => {
          // common.goHome()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mark-item-table{
  width: 100%;
  border: 1px solid #d8d8c9;
}
.subject-header{
  display: flex;
  padding: 14px 24px;
  justify-content: space-between;
}
.cell{
  display: inline-block;
  padding: 0 2%;
  width: calc(46% - 3px);
  &:nth-child(odd){
    border-right: 1px solid #e9e9e0;
  }
}
.cell-room{
  display: flex;
  justify-content: space-between;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e9e9e0;
  .divid-name{
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.mark-item-body{
  box-shadow: inset 0px 4px 12px -4px rgba(0, 0, 0, 0.3),
              inset 0px -4px 12px -4px rgba(0, 0, 0, 0.2);
  height: 360px;
  overflow: auto;
}
.hollow-btn{
  border: 1px solid $color-label;
  outline: none;
  padding: 4px 6px;
  background: #fff;
  border-radius: 4px;
  color: $color-label;
  font-weight: bold;
  &:hover{
    border-color: #7bc07c;
    color: #7bc07c;
  }
  &:active{
    border-color: #356e35;
    color: #356e35;
  }
  &:disabled{
    border-color: #d2d2d2;
    color: #d2d2d2;
  }

}
.has-clicked{
  background-color: #d8e8d9;
}
.btn-re-open{
  font-size: 12px;
}
.line{
  color: #e9e9e0;
  margin: 0 12px;
}
.marking{
  color: $color-label;
  font-weight: bold;
  margin-left: 10px;
  button{
    cursor: pointer;
  }
}
.unopened{
  color: $color-off;
}
.error-tip{
  color: #ff0000;
}
.check-fail{
  margin-right: 4px;
  font-size: 22px;
  vertical-align: middle;
  color: #ff0303;
}
.fail-label{
  padding: 4px 6px;
  border: 1px solid #ff0303;
  border-radius: 4px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/exam/open-pre-mark/SelectMarkItem.vue